import { gql } from "graphql-tag";

export const SEND_REQUEST = gql`
mutation send_request($input: demo_request_input!){
  send_demo_request(input: $input)
}
`